module.exports = __webpack_public_path__ + "media/country_flags/rw-2566f0eb.png";